module.exports = __webpack_public_path__ + "img/gztleft.f027d7bb.png";